import { render, staticRenderFns } from "./FscModal.vue?vue&type=template&id=235fd9cc"
import script from "./FscModal.vue?vue&type=script&lang=ts"
export * from "./FscModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports